export default __webpack_public_path__ + "static/media/no.ab5727b9.mp3";